export class Menu {

    menuFirmante = [
      {
        label: 'Inicio',
        link: 'inicio',
        faIcon: 'fas fa-home',
      },
      {
        label: 'Firma de Constancias',
        faIcon: 'fab fa-500px',
        items: [
          {
            label: 'Alumnos',
            link: 'gestionconstanciafirma/a',
            faIcon: 'fas fa-file-signature',
          },
          {
            label: 'Profesores',
            link: 'gestionconstanciafirma/p',
            faIcon: 'fas fa-file-signature'
          },
        ]
      }
    ];


    menuAdmin = [
        {
          label: 'Inicio',
          link: 'inicio',
          faIcon: 'fas fa-home',
        },
        {
          label: 'Gestion de Constancias',
          faIcon: 'fab fa-buffer',
          items: [
            {
              label: 'Alumnos',
              link: 'gestionconstancia/a',
              faIcon: 'far fa-file-alt',
            },
            {
              label: 'Profesores',
              link: 'gestionconstancia/p',
              faIcon: 'far fa-file-alt',
            }
          ]
        },
        /*{
          label: 'Firma de Constancias',
          faIcon: 'fas fa-signature',
          items: [
            {
              label: 'Alumnos',
              link: 'gestionconstanciafirma/a',
              faIcon: 'fas fa-file-signature',
            },
            {
              label: 'Profesores',
              link: 'gestionconstanciafirma/p',
              faIcon: 'fas fa-file-signature'
            },
          ]
        },*/
        {
          label: 'Mantenimientos',
          icon: 'offline_pin',
          items: [
            {
              label: 'Usuarios',
              link: 'gestionusuario',
              faIcon: 'fas fa-address-book',
            },
            {
              label: 'Plantillas',
              link: 'gestionplantilla',
              faIcon: 'fas fa-file-word'
            },
            {
              label: 'Correo Notificacion',
              link: 'gestioncorreo',
              faIcon: 'fas fa-envelope-square'
            }
          ]
        },
        {
          label: 'Reportes',
          icon: 'book',
          items: [
            {
              label: 'Total alumnos',
              link: 'reportetotalalumnos',
              faIcon: 'fas fa-table',
            },
            {
              label: 'Constancias por curso',
              link: 'reporteemitidos',
              faIcon: 'fas fa-table',
            }
          ]
        },
        {
          label: 'Item 4',
          link: '/item-4',
          icon: 'star_rate',
          hidden: true
        }
    ];

    menuSuperAdmin = [
      {
        label: 'Inicio',
        link: 'inicio',
        faIcon: 'fas fa-home',
      },
      {
        label: 'Gestion de Constancias',
        faIcon: 'fab fa-buffer',
        items: [
          {
            label: 'Alumnos',
            link: 'gestionconstancia/a',
            faIcon: 'far fa-file-alt',
          },
          {
            label: 'Profesores',
            link: 'gestionconstancia/p',
            faIcon: 'far fa-file-alt',
          }
        ]
      },
      {
        label: 'Firma de Constancias',
        faIcon: 'fas fa-signature',
        items: [
          {
            label: 'Alumnos',
            link: 'gestionconstanciafirma/a',
            faIcon: 'fas fa-file-signature',
          },
          {
            label: 'Profesores',
            link: 'gestionconstanciafirma/p',
            faIcon: 'fas fa-file-signature'
          },
        ]
      },
      {
        label: 'Mantenimientos',
        icon: 'offline_pin',
        items: [
          {
            label: 'Usuarios',
            link: 'gestionusuario',
            faIcon: 'fas fa-address-book',
          },
          {
            label: 'Plantillas',
            link: 'gestionplantilla',
            faIcon: 'fas fa-file-word'
          },
          {
            label: 'Correo Notificacion',
            link: 'gestioncorreo',
            faIcon: 'fas fa-envelope-square'
          }
        ]
      },
      {
        label: 'Reportes',
        icon: 'book',
        items: [
          {
            label: 'Total alumnos',
            link: 'reportetotalalumnos',
            faIcon: 'fas fa-table',
          },
          {
            label: 'Constancias por curso',
            link: 'reporteemitidos',
            faIcon: 'fas fa-table',
          }
        ]
      },
      {
        label: 'Item 4',
        link: '/item-4',
        icon: 'star_rate',
        hidden: true
      }
  ];
}
